import { combineReducers } from 'redux'
import login from '../../../common/reducers/login'
import language from '../../../common/reducers/language'
import cancelPolicies from '../../../common/reducers/classification/cancel_policies'
import roomTypes from '../../../common/reducers/classification/room_types'
import propertyTypes from '../../../common/reducers/classification/property_types'
import listing from '../../../common/reducers/listing'
import search from '../../../common/reducers/search'
import reviews from '../../../common/reducers/reviews'
import bedTypes from '../../../common/reducers/room_group/bed_types'
import modal from '../../../common/reducers/modal'
import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
  login,
  language,
  listing,
  cancelPolicies,
  roomTypes,
  propertyTypes,
  search,
  reviews,
  bedTypes,
  modal,
  form: formReducer
})
export default rootReducer
